import { Model as r } from "../../../../api/model.js";
import { Status as o } from "../../../../../../common/shared/status.js";
class f extends r {
  constructor(e) {
    super(), this.menu = e.menu, this.menuName = e.menuName, this.status = e.status;
  }
  getMenuName() {
    var e, t, u, s, n, m;
    return this.menu === void 0 ? this.menuName ?? "" : ((t = (e = this.menu) == null ? void 0 : e.manual) == null ? void 0 : t.status) === o.ENABLED ? ((s = (u = this.menu.manual) == null ? void 0 : u.ids) == null ? void 0 : s.join(",")) ?? "" : (((m = (n = this.menu) == null ? void 0 : n.language) == null ? void 0 : m.items) ?? []).flatMap((i) => i.menus.map((a) => `${a.id}__${i.language}`)).join(",");
  }
}
export {
  f as CustomizationServiceModel
};
//# sourceMappingURL=services.model.js.map
